import {
  ApiErrorResponse,
  ApiErrorResponseFromAbnLookup,
} from '@/common/Response';
import { toast } from 'sonner';

const defaultError = 'Something went wrong';

export const handleError = (
  error: ApiErrorResponse | ApiErrorResponseFromAbnLookup,
): void => {
  if (
    'error' in error &&
    typeof error.error === 'object' &&
    'message' in error.error
  ) {
    toast.error(error.error.message || defaultError);
    return;
  }

  if (Array.isArray((error as ApiErrorResponse)?.message)) {
    for (const message of (error as ApiErrorResponse)?.message) {
      toast.error(message || defaultError);
    }
    return;
  }
  toast.error((error as ApiErrorResponse)?.message || defaultError);
};
